import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppAdminModule } from './app/app-admin.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  console.log = function () {};
  console.error = function () {};
}
platformBrowserDynamic().bootstrapModule(AppAdminModule).then();



// WEBPACK FOOTER //
// ./src/main.ts